import React from "react";

function ArrowLeftIcon() {
  return (
    <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Atoms/Slider" transform="translate(-1.000000, -1.000000)">
          <g id="arrow_left" transform="translate(1.000000, 1.000000)">
            <circle
              id="Oval"
              stroke="#000000"
              strokeWidth="2"
              transform="translate(20.000000, 20.000000) rotate(-180.000000) translate(-20.000000, -20.000000) "
              cx="20"
              cy="20"
              r="19"
            ></circle>
            <path
              d="M19.3384436,16.2899133 L23.9957576,23.4550116 C24.2967463,23.9180713 24.1653619,24.5374549 23.7023023,24.8384436 C23.540092,24.9438803 23.3507799,25 23.157314,25 L13.842686,25 C13.2904013,25 12.842686,24.5522847 12.842686,24 C12.842686,23.8065341 12.8988058,23.6172219 13.0042424,23.4550116 L17.6615564,16.2899133 C17.9625451,15.8268536 18.5819287,15.6954692 19.0449884,15.996458 C19.1622516,16.0726791 19.2622225,16.17265 19.3384436,16.2899133 Z"
              id="Triangle"
              fill="#000000"
              transform="translate(18.500000, 20.000000) rotate(-90.000000) translate(-18.500000, -20.000000) "
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default ArrowLeftIcon;
